module.exports = __webpack_public_path__ + "img/no-activities.d284d0ad.webp";